import { CheckoutFacialRecognitionProcess } from 'modules/checkout/infra/adapters';
import { makeStorageProvider } from 'shared/infra/providers';

/**
 * A marca de facial concluído vale por orçamento e por cliente — é o que evita pedir o
 * facial de novo quando o cliente troca de forma de pagamento dentro do mesmo checkout.
 *
 * A comparação é feita pela chave serializada: `key` é um array, e comparar array com
 * `===` compara referências, que nunca coincidem entre o que veio do storage e o que
 * acabou de ser montado. Só a chave entra na conta porque o repositório de
 * reconhecimento escreve em `process.params`, então o objeto gravado diverge do novo.
 */
export default function hasValidFacialRecognition(params: {
  budgetId: number;
  customerId: number;
}) {
  const process = new CheckoutFacialRecognitionProcess(params);

  const storedProcesses = makeStorageProvider().get(
    'VALID_FACIAL_RECOGNITIONS',
  );

  return !!storedProcesses?.some(
    storedProcess => storedProcess.key?.join('|') === process.key.join('|'),
  );
}
